<template>
  <!--点击要晒的福利券-->
  <div class='moreTicks_wrapper' v-if="myWelfares.length>0" >
   <div class="selectCouponTitle">
     <span>点击选择要晒的福利券，可多选</span>
   </div>
   <div class="couponListBox">
     <div class="swiper-container">
       <div class="swiper-wrapper">
       <!-- <div class="couponListBox"> -->
       <div  v-for="(item,index) in myWelfares" class="couponPicItem swiper-slide" @click="selectedWelfare(index)">
         <img :src="item.listPic" class="couponPic" />
         <div class="selected_wrapper" v-if="item.selected">
           <div class="icon-right icon_right_color"></div>
         </div>
       </div>
       <!-- </div> -->
     </div>
      </div>
   </div>
 </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import SwiperVue from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  export default {
    name:'baskWelfare',
    props:['myWelfares'],
    data() {
      return{
        page:1,
        pageSize:10,
        openid:'oYwsd0SVGOkjpOd1VsWBZDxeSSUQ',
      }
    },
    created () {
      //this.login()
      console.log(this.myWelfares)


    },
    methods:{
      selectedWelfare(index){
        this.$emit('selectedWelfareParent',index)
      }
    },
    mounted(){
      this.$nextTick(() => {
       var mySwiper = new SwiperVue('.swiper-container', {
         "autoplay": "true",
         "slidesPerView" : '3',
         'direction': 'horizontal',
          'loop': "true",
       })
     })
    }
  }
</script>
<style lang="stylus">
  .moreTicks_wrapper
    width: 100%
    text-align: left
    padding:40px 30px
    border-top:1px solid #e5e5e5
    /*px*/
    background: #fff
    box-sizing: border-box
    .selectCouponTitle
      font-size: 30px
      color: #333
    .couponListBox
      padding-top: 30px
      width:660px
      .couponPicItem
        width: 200px
        height: 200px
        position: relative
        display: inline-block
        .couponPic
          width:200px
          height:200px
          display:block
        .selected_wrapper
          width: 200px
          height: 200px
          background: rgba(0,0,0,0.6)
          position: absolute
          left: 0px
          top: 0px
          .icon_right_color
            width: 40px
            height: 40px
            color:#625a4c
            font-size: 24px
            text-align: center
            background: #fff
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%,-50%)
            border-radius: 50%
            line-height: 40px
</style>



// WEBPACK FOOTER //
// src/components/quan/baskWelfare.vue